import React, { useState } from 'react';
import RolledCharacter from 'react/elements/character/RolledCharacter';

function imageSourcesFor(character) {
	if(!character) {
		return [];
	}
	const sources = [];
	if(character.stock_icon_url) {
		sources.push({ url: character.stock_icon_url, isPortrait: false });
	}
	if(character.image_url) {
		sources.push({ url: character.image_url, isPortrait: true });
	}
	return sources;
}

// A character's stock icon, drawn before a name in chat. Only Melee has stock
// icons; other games fall back to the character image scaled down (--portrait).
// An image that fails to load falls through to the next one, so a bad URL never
// leaves a broken image. Without any image it keeps an empty slot of the same
// size so names line up. `decorative` leaves the alt text empty, for a copy of
// the icon a screen reader has already heard (the chat avatar's).
// `rolledCharacter` pins what a Random pick landed on to the icon's corner.
export default function CharacterStockIcon({ character, className = '', decorative = false, rolledCharacter = null }) {
	const sources = imageSourcesFor(character);
	const sourceKey = sources.map((source) => source.url).join('|');
	const [failed, setFailed] = useState({ sourceKey, count: 0 });
	const failedCount = failed.sourceKey === sourceKey ? failed.count : 0;
	const source = sources[failedCount];

	if(!source) {
		return <span className={`chat-stock-icon chat-stock-icon--empty ${className}`} aria-hidden='true' />;
	}
	return (
		<RolledCharacter rolledCharacter={rolledCharacter}>
			<img
				key={source.url}
				className={`chat-stock-icon${source.isPortrait ? ' chat-stock-icon--portrait' : ''} ${className}`}
				src={source.url}
				alt={decorative ? '' : character.name}
				title={character.name}
				loading='lazy'
				onError={() => setFailed({ sourceKey, count: failedCount + 1 })}
			/>
		</RolledCharacter>
	);
}
